import { ProcessStatus } from "../entity/ProcessStatus";
import { ProductDetailsState } from "../entity/state/ProductDetailsState";

export const initialProductDetailsState: ProductDetailsState = {
    product: null,
    status: ProcessStatus.None
};